// development hardware prices// placeholder file for local testing. Will be replaced by the *.{environment}.ts files during deploy
import shipping_options from './shipping.dev'

export default [
    {
        label: 'Bat Attachment',
        description: 'for Quest 3/3S',
        stripe_product_id: 'prod_OjISmPKQl31pFw',
        stripe_price_id: 'price_1NvprPIDrm6Z6HgY4XZxr5qE',
        price: 2500,
        wc_id: 1417,
        category: 'bat_attachment',
        variants: [
            {
                color: 'purple',
                color_hex: '#8a2be2',
                image_uri: null,
                wc_id: 1417,
                category: 'bat_attachment',
            },
            {
                color: 'black',
                color_hex: '#000000',
                image_uri: null,
                wc_id: 2181,
                category: 'bat_attachment',
            },
        ],
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 2',
        stripe_product_id: 'prod_IPR22gSmDE8en4',
        stripe_price_id: 'price_1Ln2sgIDrm6Z6HgYThiP2iws',
        price: 2500,
        wc_id: 1416,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 3/3S',
        stripe_product_id: 'prod_OjISmPKQl31pFw',
        stripe_price_id: 'price_1NvprPIDrm6Z6HgY4XZxr5qE',
        price: 0,
        msrp: 2500,
        coupon: 'UymvaGmK',
        wc_id: 1518,
        category: 'bat_attachment',
        variants: [
            {
                color: 'purple',
                color_hex: '#8a2be2',
                image_uri: null,
                wc_id: 1518,
                category: 'bat_attachment',
            },
            {
                color: 'black',
                color_hex: '#000000',
                image_uri: null,
                wc_id: 2171,
                category: 'bat_attachment',
            },
        ],
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment ',
        description: 'for Quest 2',
        stripe_product_id: 'prod_IPR22gSmDE8en4',
        stripe_price_id: 'price_1Ln2sgIDrm6Z6HgYThiP2iws',
        price: 0,
        msrp: 2500,
        coupon: 'UymvaGmK',
        wc_id: 1519,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    // {
    //     label: 'Short Bat ($99 value)',
    //     description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
    //     stripe_product_id: 'prod_P3DtqbMutjS0bF',
    //     stripe_price_id: 'price_1OF7RRIDrm6Z6HgYPttYdyV8',
    //     price: 0,
    //     wc_id: 2777,
    //     category: 'short_bat',
    //     shipping_options: shipping_options.filter(option => option.value === 'standard'),
    //     max_quantity: 1,
    //     available_for: ['standard_yearly', 'pro_yearly'],
    // },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
        stripe_product_id: 'prod_P3DtqbMutjS0bF',
        stripe_price_id: 'price_1OF7RRIDrm6Z6HgYPttYdyV8',
        price: 9900,
        wc_id: 2776,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 20,
        available_for: ['standard_monthly'],
    },
    {
        label: 'Short Bat (-30%)',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
        stripe_product_id: 'prod_P3DtqbMutjS0bF',
        stripe_price_id: 'price_1P5sieIDrm6Z6HgYYFZzHbQm',
        price: 6930,
        wc_id: 6437,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        available_for: [],
    },
    // {
    //     label: 'Short Bat $99 (40% off)',
    //     description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
    //     stripe_product_id: 'prod_P3DtqbMutjS0bF',
    //     stripe_price_id: 'price_1PblFjIDrm6Z6HgYYuMIMc7F',
    //     price: 6000,
    //     wc_id: 8031,
    //     category: 'short_bat',
    //     shipping_options: shipping_options.filter(option => option.value === 'standard'),
    //     max_quantity: 1,
    //     available_for: [],
    // },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
        stripe_product_id: 'prod_P3DtqbMutjS0bF',
        stripe_price_id: 'price_1PbNq8IDrm6Z6HgYXMSd9gg3',
        price: 7400,
        msrp: 9900,
        wc_id: 7588,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        available_for: ['standard_yearly', 'pro_monthly', 'pro_yearly'],
    },
    {
        label: 'Limited Edition WIN Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
        stripe_product_id: 'prod_R7jj9U8Xf5pNMt',
        stripe_price_id: 'price_1QFUFxIDrm6Z6HgYd5RGiPjz',
        price: 9900,
        wc_id: 9294,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 2,
        available_for: [],
    },
    {
        label: 'Limited Edition WIN Short Bat (-40%)',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3/3S headsets.',
        stripe_product_id: 'prod_R7jj9U8Xf5pNMt',
        stripe_price_id: 'price_1QFUGQIDrm6Z6HgYFWUvbgCX',
        price: 6000,
        msrp: 9900,
        wc_id: 9295,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 2,
        available_for: [],
    },
    {
        label: 'Meta Quest 2 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_P65ZNTjEKUKxAA',
        stripe_price_id: 'price_1P6YY9IDrm6Z6HgYDxnsl2WE',
        price: 42900,
        wc_id: 2984,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
    },
    {
        label: 'Meta Quest 3 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_QMnsxh8il4Xxno',
        stripe_price_id: 'price_1PW4GhIDrm6Z6HgYD311Cr3D',
        price: 72700,
        wc_id: 7731,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['standard_yearly'],
    },
    {
        label: 'Meta Quest 3 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_QMnsxh8il4Xxno',
        stripe_price_id: 'price_1PW4GhIDrm6Z6HgYvyeVg8mG',
        price: 85400,
        wc_id: 7730,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['pro_yearly'],
    },
    {
        label: 'Meta Quest 3 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_QMnsxh8il4Xxno',
        stripe_price_id: 'price_1PpZltIDrm6Z6HgYGCjjMhl6',
        price: 60500,
        wc_id: 8530,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['pro_yearly'],
    },
    {
        label: 'Meta Quest 3S Headset', // Standard Annual Bundle
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_Qxsy1w2wiqJCQp',
        stripe_price_id: 'price_1PW4GhIDrm6Z6HgYvyeVg8mG',
        price: 52700,
        wc_id: 9371,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['standard_yearly'],
    },
    {
        label: 'Meta Quest 3S Headset', // Pro Annual Bundle
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_Qxsy1w2wiqJCQp',
        stripe_price_id: 'price_1Q5xDLIDrm6Z6HgYNre1TAtb',
        price: 65400,
        wc_id: 9370,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['pro_yearly'],
    },
    {
        label: 'Meta Quest 3S Headset', // Pro Annual Bundle - Holiday Deal
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_Qxsy1w2wiqJCQp',
        stripe_price_id: 'price_1Q8QSwIDrm6Z6HgY1LC6xeuh',
        price: 54800,
        wc_id: 9306,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: true,
        available_for: ['pro_yearly_holiday'],
    },
    {
        label: 'BRUCE BOLT wristbands',
        description: '',
        stripe_product_id: 'bruce_bolt_wristbands',
        stripe_price_id: 'bruce_bolt_wristbands',
        price: 0,
        wc_id: 9311,
        category: 'bruce_bolt_wristbands',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: false,
        available_for: ['standard_yearly_holiday'],
    },
    {
        label: 'BRUCE BOLT headband',
        description: '',
        stripe_product_id: 'bruce_bolt_headband',
        stripe_price_id: 'bruce_bolt_headband',
        price: 0,
        wc_id: 9312,
        category: 'bruce_bolt_headband',
        shipping_options: shipping_options.filter(option => option.value === 'standard'),
        max_quantity: 1,
        bundle_only: false,
        available_for: ['standard_yearly_holiday'],
    },
] as Hardware[]